
    // TEXT input for "ProductOverview"
    const input = {
    // Product REVIEWS
    reviews: {
        href: 'https://www.google.com/',
        average: 4,
        totalCount: 117
    },

    // Product DESCRIPTIONS
    product: {
        // General Information about the product
        name: 'Nike Sportswear Premium Essentials',
        price: '$45',
        to: 'men/men/clothing/tops/nike1/Nike1',
        id: 'product-men-nike1',
        
        // Product Breadcrumbs
        breadcrumbs: [
            { id: 1, name: 'Men', to: '/men/clothing' },
            // { id: 2, name: 'Clothing', to:'/men/clothing'},
            // { id: 3, name: 'Tops', to: '/men/clothing/tops' },
        ],

        //Product Images
        images: [
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-1.jpg',
            alt: 'image 1',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-2.jpg',
            alt: 'image 2',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-3.jpg',
            alt: 'image 3',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-4.jpg',
            alt: 'image 4',
            },
        ],

        // Product Colors
        colors: [
            { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
            { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
            { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
        ],

        // Product Sizing
        sizes: [
            { name: 'XS', inStock: true },
            { name: 'S', inStock: true },
            { name: 'M', inStock: true },
            { name: 'L', inStock: true },
            { name: 'XL', inStock: true },
            { name: 'XXL', inStock: true },
        ],

        // Product Introduction
        description:
            "Summer T-Shirt—Slip into summer comfort with our lightweight, breathable T-shirt. Made from a soft, high-quality cotton blend, it's designed to keep you cool and stylish on even the hottest days. Perfect for beach trips, barbecues, or just lounging around!",
        
        // Product Bulletpoints
        highlights: [
            'Shown: Space Purple',
            'Style: DO7392-567',
        ],
        
        // Product Additional Information
        details:
            'This product is made with at least 75% organic cotton fibers',
    },

    // Personalized Recommendation per Product
    recommendation: [
        // {
        //     id: 1,
        //     name: 'Basic Tee',
        //     category: "Men's T-Shirts",
        //     href: '/men/clothing/tops/nike1',
        //     imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/1/product_men_1-1.jpg',
        //     imageAlt: "Front of men's Basic Tee in black.",
        //     price: '$35',
        //     color: 'Black',
        // },
        {
            id: 2,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/bottoms/zara1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/2/product_men_2-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 3,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike3',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/3/product_men_3-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 4,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/4/product_men_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 4,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/men/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/men/4/product_men_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // More products...
    ]

    }

    export default input
    
